import React, {useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import * as emitter from '../../global/emitter';
import {Portal} from '../../util';
import {SubHeaderDisclosure} from './disclosure/sub-header-disclosure';

declare const collapse: {
    init: () => void;
};

const Yotpo: React.FC = observer(() => {
    const initRef = useRef(false);

    useEffect(() => {
        const abForceUpdate = async () => {};

        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', abForceUpdate);

        const scriptId = 'yotpo-widget-script';
        const timeoutId = setTimeout(() => {
            if (!document.getElementById(scriptId)) {
                const script = document.createElement('script');

                script.id = scriptId;
                script.type = 'text/javascript';
                script.defer = true;
                script.src = '//staticw2.yotpo.com/H8vQ6ytRf3Uo0eAAlJJh85FR61IeET7EXRvzKasQ/widget.js';

                const firstScript = document.getElementsByTagName('script')[0];

                firstScript.parentNode?.insertBefore(script, firstScript);
            }
        }, 1750);

        return () => {
            clearTimeout(timeoutId);
            emitter.eventEmitter.unsubscribe(emitter.EventType.AB, 'ab');
            const existingScript = document.getElementById(scriptId);

            if (existingScript) {
                existingScript.remove();
            }
        };
    }, []);

    useEffect(() => {
        if (!initRef.current && s.ready && !s.ps.is_caf) {
            initRef.current = true;
            collapse.init();
        }
    });

    if (!s.ready) {
        return null;
    }

    if (!s.ps.is_caf) {
        return (
            <div id="prod-reviews">
                <SubHeaderDisclosure
                    buttonId="prod-reviews-click"
                    panelId="yotpo-main"
                    title="Customer Reviews"
                    defaultOpen={true}
                >
                    <div
                        className="yotpo yotpo-main-widget"
                        id="divYotpo"
                        data-product-id={s.prod.ProductID}
                        data-name={s.ui.product_title}
                        data-currency="$"
                        data-price={s.ui.price}
                        data-url={s.si.URL}
                        data-image-url={s.prod.CustomizationMethod >= 2 ? `${Portal?.IMGDomain}/i/${s.prod.ProductID}_220_250.png` : `${s.prod.Image_Thumb}`}
                    />
                </SubHeaderDisclosure>
            </div>
        );
    }

    return null;
});

export default Yotpo;
